<!-- 压接孔 -->
<template>
  <BaseFormItem
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isShowNewIcon="isShowNewIcon"
  >
    <BaseRadioGroup v-model="val" @change="handleChange">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    // 表面处理
    spray: {
      type: String,
      default: ''
    },
    // 半孔
    bankong: {
      type: Number,
      default: 0
    },
    // 包边
    baobian: {
      type: Number,
      default: 0
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('press_fit_hole')
    },
    options() {
      const { val, fields, bankong, baobian } = this
      const options = fields.options
      // 当半孔或包边任意一个字段有值时，禁用选项 有（孔径公差+/-0.05mm）
      let disabledOptions = (bankong > 0 || baobian > 0) ? [1] : []
      // 如果当前项被禁用，选中第一个可选的选项
      if (disabledOptions.includes(val)) {
        this.changeVal(0)
      }
      
      return options.map(item => ({...item, disabled: disabledOptions.includes(item.value) }))
    },
    // 是否显示 NEW 标识
    isShowNewIcon() {
      return new Date().getTime() <= new Date('2025-08-10').getTime()
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleChange(val) {
      this.handleEmit()
      
      if (val == 1) {
        const tips = `
          <div style="text-align: left;">
            ${!['沉金', 'OSP'].includes(this.spray) ? '<p>有压接孔，请修改为沉金或OSP工艺。</p>' : ''}
            <p>请在备注或文件中描述，哪些孔需要做压接孔，并填写对应位号信息。</p>
          </div>
        `
        this.$alert(tips, '温馨提示', {
          center: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
        })
      }
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss">
</style>